import { AdminUserPermissionsEnum } from '@/lib/enum';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TDataVariables = {
  permissions: AdminUserPermissionsEnum[];
  employee: boolean;
  userId: string;
  root: boolean;
};
type TResponseData = void;

export const useRequestEditEmployeePermissions = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.employees.base, 'editPermissions'],
    mutationFn: ({ userId, ...data }: TDataVariables) =>
      apiClient
        .put<TResponseData>(routes.api.employees.editPermissions(userId), data)
        .then(handleApiResponse),
    onSuccess: () => invalidate(routes.api.employees.base)
  });

  const triggerEditPermissions = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingEditPermissions: isPending,
    triggerEditPermissions,
    error
  });

};
